// Puerto verbatim de packages/hce/src/hce/offline/db.ts — IndexedDB nativo,
// sin librería, dos object stores: "outbox" (escrituras pendientes) y
// "readCache" (última copia conocida de cada GET exitoso).
const DB_NAME = 'logiacare-hce-offline';
const DB_VERSION = 1;
export const STORE_OUTBOX = 'outbox';
export const STORE_READ_CACHE = 'readCache';

let dbPromise: Promise<IDBDatabase> | undefined;

export function abrirDb(): Promise<IDBDatabase> {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, DB_VERSION);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains(STORE_OUTBOX)) {
          db.createObjectStore(STORE_OUTBOX, { keyPath: 'localId' });
        }
        if (!db.objectStoreNames.contains(STORE_READ_CACHE)) {
          db.createObjectStore(STORE_READ_CACHE, { keyPath: 'url' });
        }
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  return dbPromise;
}

export async function idbGetAll<T>(store: string): Promise<T[]> {
  const db = await abrirDb();
  return new Promise((resolve, reject) => {
    const req = db.transaction(store, 'readonly').objectStore(store).getAll();
    req.onsuccess = () => resolve(req.result as T[]);
    req.onerror = () => reject(req.error);
  });
}

export async function idbGet<T>(store: string, key: string): Promise<T | undefined> {
  const db = await abrirDb();
  return new Promise((resolve, reject) => {
    const req = db.transaction(store, 'readonly').objectStore(store).get(key);
    req.onsuccess = () => resolve(req.result as T | undefined);
    req.onerror = () => reject(req.error);
  });
}

export async function idbPut<T>(store: string, value: T): Promise<void> {
  const db = await abrirDb();
  return new Promise((resolve, reject) => {
    const req = db.transaction(store, 'readwrite').objectStore(store).put(value);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

export async function idbDelete(store: string, key: string): Promise<void> {
  const db = await abrirDb();
  return new Promise((resolve, reject) => {
    const req = db.transaction(store, 'readwrite').objectStore(store).delete(key);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}
